export const isDev =
  process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const isDevOrPreview = isDev || isPreview
